import { render, staticRenderFns } from "./BpmBizBatchRestartDealModal.vue?vue&type=template&id=24560257&scoped=true&"
import script from "./BpmBizBatchRestartDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizBatchRestartDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizBatchRestartDealModal.vue?vue&type=style&index=0&id=24560257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24560257",
  null
  
)

export default component.exports